// The Add form for an estate item of one of the given types, or of any type when there are none,
// returning to `back` once it's sent
export const addEstateItemPath = (caseRef, types, back) => {
  const params = new URLSearchParams();
  if (types.length > 0) params.set("types", types.join(","));
  if (back) params.set("back", back);
  return `/dashboard/${caseRef}/estate/add?${params}`;
};
